
































































































































































import { Component, Provide, Vue, Watch } from "vue-property-decorator";
import Bus from "@/JS/Bus";
import { getCookie } from "@/JS/cookie"; //使用getCookie方法
import httpApi from "@/API/Tenant/Weixin";
import TemplateMessagePopUp from "@/components/TemplateMessagePopUp.vue";
@Component({
  components: { TemplateMessagePopUp }
})
export default class extends Vue {
  @Provide()
  private scrollHeight = 600; //当前高度
  private formInline: any = {};
  private form: any = {};
  private dialogVisible: boolean = false;
  private dialogTemplateMessagePopUpVisible: boolean = false;
  private tableData: any = [];
  private WxQrCode: any;
  private TemplateMessage: any = {};
  //初始化数据
  data() {
    return {
      rules: {
        PrizeName: [
          { required: true, message: "请输入奖品名称", trigger: "blur" }
          //{ min: 1, max: 4, message: "长度在 1 到 4 个字符", trigger: "blur" }
        ],
        Number: [
          { required: true, message: "请输入奖品数量", trigger: "change" }
        ],
        Received: [
          { required: true, message: "请输入奖品数量", trigger: "change" }
        ],
        Conditions: [{ required: true, message: "请输入", trigger: "change" }],
        IsTemplateId: [
          { required: true, message: "请输入", trigger: "change" }
        ],
        TemplateId: [
          { required: true, message: "请输入模板消息Id", trigger: "blur" }
        ],
        SendTemplateTime: [
          {
            required: true,
            message: "请输入模板消息发送时间",
            trigger: "change"
          }
        ],
        Sort: [{ required: true, message: "请输入排序", trigger: "change" }],
        Status: [{ required: true, message: "请选择状态", trigger: "change" }]
      }
    };
  }
  //初始化
  created() {
    this.WxQrCode = localStorage.getItem("WxQrCode");
    this.prizeList(this.WxQrCode);
  }
  Refresh() {
    this.dialogVisible = false;
    this.prizeList(this.WxQrCode);
  }
  //关闭/确定事件
  TemplateMessageDialogconfirm() {
    this.dialogTemplateMessagePopUpVisible = false;
    this.dialogVisible = true;
    var data = localStorage.getItem("TemplateId");
    this.form.TemplateId = data;
    console.log(this.form.TemplateId);
     this.loadMessageList();
  }
  //取消事件
  TemplateMessageDialogcancel() {
    this.TemplateMessageDialogconfirm();
    this.form.TemplateId = "";
  }

  //查询数据列表
  async prizeList(WxQrCode: any) {
    this.form.TenantId = getCookie("TenantID");
    this.form.Aid = getCookie("Aid");
    this.form.PosterId = WxQrCode; // getCookie("WxQrCode");
    let params: any = {
      Input: [
        {
          Name: "model",
          Value: this.form
        }
      ]
    };
    var res: any = await httpApi.GetQrCodePrizeList(params);
    console.log(res);
    if (res.ErrorCode == 0) {
      this.tableData = res.output[0].value;
    } else {
      this.$message.error("查询数据列表失败：" + res.ErrorMessage);
    }
  }
  //修改数据
  onModify(data: any) {
    this.form = data;
    if (this.form.IsTemplateId) {
      this.form.IsTemplateId = parseInt(this.form.IsTemplateId) + "";
    }
    if (this.form.Status) {
      this.form.Status = parseInt(this.form.Status) + "";
    }
    this.dialogVisible = true;
    this.loadMessageList();
  }
  //删除数据
  onDelete(data: any) {
    this.$confirm(
      "确定要删除当前奖品信息包括核销奖品信息一起会删除，确认操作吗?",
      "提示",
      {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }
    ).then(async () => {
      data.ActionName = "DELETE";
      let params: any = {
        Input: [
          {
            Name: "model",
            Value: data
          }
        ]
      };
      // console.log(params);
      var res: any = await httpApi.SaveQrCodePrizeService(params);
      //console.log(res);
      if (res.ErrorCode == 0) {
        this.dialogVisible = false;
        this.$message.success("删除成功！");
        this.prizeList(this.WxQrCode);
      } else {
        this.$message.error("删除数据失败：" + res.ErrorMessage);
      }
    });
  }
  //格式化是否显示
  formatStatus(row: any, column: any) {
    switch (row.Status) {
      case 1:
        return "启用";
        break;
      default:
        return "禁用";
        break;
    }
  }
  //格式化是否显示
  formatIsTemplateId(row: any, column: any) {
    switch (row.IsTemplateId) {
      case 1:
        return "启用";
        break;
      default:
        return "禁用";
        break;
    }
  }
  //提交奖品配置信息
  async prizeSubmit() {
    (this as any).$refs["form"].validate(async (valid: boolean) => {
      if (valid) {
        this.form.TenantId = getCookie("TenantID");
        this.form.Aid = getCookie("Aid");
        this.form.PosterId = localStorage.getItem("WxQrCode");
        let params: any = {
          Input: [
            {
              Name: "model",
              Value: this.form
            }
          ]
        };
        // console.log(params);
        var res: any = await httpApi.SaveQrCodePrizeService(params);
        //console.log(res);
        if (res.ErrorCode == 0) {
          this.dialogVisible = false;
          this.$message.success("保存成功！");
          this.prizeList(this.WxQrCode);
        } else {
          this.$message.error("保存数据失败：" + res.ErrorMessage);
        }
      } else {
        this.$message.error("请认真填写必填项！");
      }
    });
  }
  /** 加载模板数据 */
  async loadMessageList() {
    let _this = this;
    let params: any = {
      Input: [
        {
          Name: "aid",
          Value: getCookie("Aid")
        },
        {
          Name: "status",
          Value: 1
        },
        {
          Name: "id",
          Value: _this.form.TemplateId
        }
      ]
    };
    //_this.form.TemplateId
    console.log(params);
    
    var res: any = await httpApi.GetAppMessageTemplateList(params);
    if (res.ErrorCode == 0) {
      var result = res.output[0].value;
      _this.TemplateMessage = result;
    } else {
      this.$message.error(res.ErrorMessage);
    }
  }
}
